import { render, staticRenderFns } from "./AgentManage.vue?vue&type=template&id=b35e3190&scoped=true&"
import script from "./AgentManage.vue?vue&type=script&lang=js&"
export * from "./AgentManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35e3190",
  null
  
)

export default component.exports